export const tones = {
    danger: { color: "#dc3545", background: "rgba(220, 53, 69, 0.1)" },
    warning: { color: "#b7791f", background: "rgba(236, 201, 75, 0.18)" },
    primary: { color: "#010a63", background: "rgba(1, 10, 99, 0.08)" },
};

export const smallText = { fontSize: 12 };
